export const formatReadingTime = (time?: number | string | null) => {
  let timeString = "N/A";

  if (typeof time === "number" && time > 0) {
    if (time < 30) {
      timeString = "< 30 sec";
    } else if (time >= 30 && time < 60) {
      timeString = `${time} sec`;
    } else {
      timeString = `${Math.round(time / 60)} min`;
    }
  }
  return timeString;
};
